var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleCloudBigQuery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5082_205883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7363 85.2669L64.9115 102.329H39.2057C36.9183 102.329 34.7996 101.092 33.6558 99.1042L12.8437 62.8611C11.7188 60.8924 11.7188 58.4737 12.8437 56.4863L20.7561 42.6865L30.5246 59.6737L45.2431 85.2669H74.7363Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.155 62.8617L86.3424 99.1235C85.1987 101.111 83.08 102.348 80.7926 102.348H64.9116L74.7364 85.2863L89.4549 59.6743L74.7177 34.0811H94.2735L107.136 56.4869C108.28 58.4556 108.28 60.893 107.155 62.8617Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2919 34.0809H45.2616L30.5244 59.6742L20.7559 42.687L33.6369 20.2249C34.7806 18.2375 36.8993 17 39.1867 17H80.8109C83.0984 17 85.2171 18.2375 86.3608 20.2249L94.2919 34.0809Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7361 34.0811L89.4545 59.6743L74.7173 85.2675H45.2616L30.5244 59.6743L45.2616 34.0811H74.7361Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9989 46.8682C67.0675 46.8682 72.8049 52.6056 72.8049 59.6742C72.8049 66.7428 67.0675 72.4802 59.9989 72.4802C52.9303 72.4802 47.1929 66.7428 47.1929 59.6742C47.1929 52.6056 52.9303 46.8682 59.9989 46.8682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.811 17C83.0985 17 85.2172 18.2375 86.3609 20.2249L93.992 33.5372L94.292 34.0622L86.3421 20.2062C85.2172 18.2375 83.0985 17 80.811 17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8109 17H39.2055C36.918 17 34.7993 18.2375 33.6556 20.2249L20.7559 42.687L20.9059 42.9495L33.6369 20.7499C34.7806 18.7625 36.8993 17.525 39.1867 17.525H80.8109C83.0984 17.525 85.2171 18.7625 86.3608 20.7499L93.6919 33.5372H93.9919L86.3608 20.2249C85.2171 18.2375 83.0984 17 80.8109 17Z",
    fill: "#689DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6919 33.5371H45.2616L30.5244 59.1304V59.6741L45.2616 34.0808H74.736V34.0621H93.9919L93.6919 33.5371Z",
    fill: "#3A71DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9922 33.5371L94.2922 34.0621L93.9922 33.5371Z",
    fill: "#D1D3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9924 33.5371H93.6924L93.9924 34.0621H94.2924L93.9924 33.5371Z",
    fill: "#5885DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7559 42.6865L12.8435 56.4863C12.7498 56.655 12.6561 56.8425 12.5811 57.0112C12.6561 56.8237 12.7498 56.655 12.8435 56.4863L20.7559 42.6865L30.5245 59.6737L45.2429 85.2669H74.7173H45.2617L30.5245 59.6737L20.9059 42.9678L20.7559 42.6865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7559 42.7061L12.8435 56.487C12.7498 56.6558 12.656 56.8433 12.581 57.012C12.2248 57.7808 12.0373 58.6057 12.0186 59.4682V59.412C12.0186 59.5057 12.0186 59.5995 12.0373 59.6745C12.1123 58.737 12.3935 57.837 12.8623 57.0308L20.7746 43.231L30.5432 60.2182L45.2617 85.8115H74.4173L74.7173 85.2865H45.2617L30.5244 59.6745L20.7559 42.7061Z",
    fill: "#FCC937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7559 42.6865L20.9059 42.949L20.7559 42.6865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 62.8615L33.6372 99.1233C34.7809 101.111 36.8996 102.348 39.1871 102.348H64.8928H39.2058C36.9184 102.348 34.7997 101.111 33.6559 99.1233L12.8438 62.8615Z",
    fill: "#F2D7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0187 59.4678C11.9813 60.5365 12.2062 61.6052 12.6937 62.5615C12.75 62.6552 12.7875 62.749 12.8437 62.8427L33.6371 99.1045C34.7808 101.092 36.8995 102.329 39.187 102.329H64.8927L65.1927 101.786H39.2057C36.9183 101.786 34.7996 100.567 33.6558 98.5608L12.8437 62.3177C12.375 61.5115 12.0937 60.5928 12.0187 59.674C12.0187 59.7678 12 59.8615 12 59.9365C12 59.7865 12 59.6178 12.0187 59.4678Z",
    fill: "#EFA106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2116 101.805L64.9116 102.33V102.348L65.0991 102.011L65.2116 101.805Z",
    fill: "#E1402D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0186 59.4121V59.9371C12.0186 59.8434 12.0186 59.7496 12.0373 59.6746C12.0186 59.5809 12.0186 59.4871 12.0186 59.4121Z",
    fill: "#F0AC2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7363 34.0811L89.4548 59.6743H89.7548L75.3363 34.606H75.0363L74.7363 34.0811Z",
    fill: "#C83D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1554 101.917L65.0991 102.01L65.0616 102.067L65.1554 101.917ZM107.961 59.6738C107.886 60.6113 107.605 61.5113 107.136 62.3175L86.3424 98.5981C85.1987 100.586 83.08 101.823 80.7926 101.823H65.5116L65.2116 102.348H64.9116H80.7926C83.08 102.348 85.1987 101.111 86.3424 99.1231L107.155 62.8613C107.698 61.9238 107.98 60.8551 107.998 59.7676V59.9363C107.98 59.8426 107.98 59.7676 107.961 59.6738Z",
    fill: "#C83D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0991 102.011L64.9116 102.348V102.329L65.0616 102.067L65.0991 102.011Z",
    fill: "#C03B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.292 34.0811L107.135 56.4869C107.398 56.9369 107.585 57.4056 107.735 57.8743C107.604 57.3868 107.398 56.9181 107.135 56.4681L94.292 34.0811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7548 59.6743H89.4548L74.7176 85.2676L65.1553 101.898L65.2115 101.805H65.5115L74.7176 85.7925L89.7548 59.6743ZM94.2922 34.0811H75.0363L75.3363 34.606H94.2922L107.154 57.0306C107.623 57.8368 107.904 58.7556 107.979 59.6743C107.979 59.5806 107.998 59.4868 107.998 59.4118V59.7681C108.017 59.1306 107.923 58.4931 107.754 57.8931C107.604 57.4056 107.417 56.9369 107.154 56.5056L94.2922 34.0811Z",
    fill: "#EE695D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9922 34.0625H74.7363V34.0812H75.0363H93.9922V34.0625Z",
    fill: "#618DE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2922 34.0625H93.9922V34.0812H94.2922V34.0625Z",
    fill: "#799DE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0363 34.0811H74.7363L75.0363 34.606H75.3363L75.0363 34.0811Z",
    fill: "#D3645A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5302 101.805H65.2302L65.1739 101.899L65.0802 102.068L64.9302 102.33H65.2302L65.5302 101.805ZM107.979 59.4121C107.979 59.5059 107.979 59.5996 107.961 59.6746C107.961 59.7684 107.979 59.8621 107.979 59.9371V59.7684C107.998 59.6371 107.979 59.5246 107.979 59.4121Z",
    fill: "#D3645A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0616 102.067L64.9116 102.33L65.0616 102.067Z",
    fill: "#CD6255"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5082_205883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 85.3483,
    fill: "white",
    transform: "translate(12 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloudBigQuery);
export default __webpack_public_path__ + "static/media/google-cloud-big-query.92d6fe926aec6f53463262b254c0e775.svg";
export { ForwardRef as ReactComponent };